import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  text: 'Descarga el manual PDF inmediatamente a tu teléfono o computadora.'
}, {
  num: '2',
  text: 'Sigue la secuencia de 3 pasos para activar tu flujo de nitrógeno.'
}, {
  num: '3',
  text: 'Recupera la confianza de saber que el control de tu cuerpo vuelve a ser tuyo.'
}];
export function HowItWorksSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-93">
            CÓMO FUNCIONA
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-94"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-95">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-800 -translate-y-1/2 z-0" data-id="element-96"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-97">
              <div className="w-16 h-16 rounded-full bg-slate-950 border-2 border-blue-500 flex items-center justify-center text-2xl font-bold text-blue-400 mb-6 shadow-[0_0_15px_rgba(37,99,235,0.3)]" data-id="element-98">
                {step.num}
              </div>
              <p className="text-lg text-slate-300 font-medium" data-id="element-99">{step.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}